import React from 'react';
import styled from '@emotion/styled';
import { Button, Typography } from 'antd';
import { HomeWidgetsForm } from '../../../../types/home';
import { appStyles } from '../../../../styles';

interface HandicapPreviewProps {
  values: HomeWidgetsForm;
}

const { Text } = Typography;

export const HandicapPreview = (props: HandicapPreviewProps) => {
  const { values } = props;
  return (
    <StyledHandicapPreview>
      <Text className="heading">{values.heading}</Text>
      <div className="wrap-text">
        <Text className="title">{values.title}</Text>
      </div>
      {values.ctaText && (
        <div className="wrap-btn">
          <Button className="ctaText">{values.ctaText}</Button>
        </div>
      )}
    </StyledHandicapPreview>
  );
};

const StyledHandicapPreview = styled.div`
  width: 75%;
  min-height: 297px;
  ${appStyles.borderGray}
  ${appStyles.borderRadiusModal}
  margin: 30% 12.5% 0;
  background: transparent linear-gradient(180deg, #7a91be 0%, #4e5157 100%) 0% 0% no-repeat padding-box;
  position: relative;
  padding: 0.75rem;
  & .heading {
    position: absolute;
    top: -48px;
    left: 0;
    font-size: 16px;
  }
  & .description,
  & .title {
    font-size: 14px;
    ${appStyles.color.white}
  }
  & .wrap-description {
    padding-bottom: 1rem;
    padding-top: 0.5rem;
  }
  & .wrap-text {
    position: absolute;
    top: 35%;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    width: 86%;
  }
  & .wrap-btn {
    align-items: center;
    justify-content: center;
    display: flex;
  }
  & .ctaText {
    position: absolute;
    bottom: 1.2rem;
    border-radius: 10px;
    height: 36px;
  }
`;
